export enum DashboardAppActionTypes {
  LOGOUT = 'LOGOUT',
  GET_ACCOUNTS_LIST = 'GET_ACCOUNTS_LIST',
  ON_ACCOUNT_CHANGE = 'ON_ACCOUNT_CHANGE',
  GET_CURRENT_FROM_STORE = 'GET_CURRENT_FROM_STORE',
  SEARCH_TERM_CHANGE = 'SEARCH_TERM_CHANGE',
}
